<template lang="html">
  <div id="info-page-s2">

    <section class="info-section-1">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-text">
            <h1 class="title-s1">EUM LEGAL</h1>

            <p>
              EUM Legal: Tu Aliado en la Legalidad del Cannabis en México.<br />
              <br />
              Ofrecemos asesoría legal especializada en productos y servicios relacionados con el cannabis en México.<br />
              <br />
              Desarrollamos estrategias jurídicas personalizadas para garantizar el cumplimiento regulatorio, permisos de importación, autorizaciones para uso lúdico y más.<br />
              <br />
              En EUM, hemos diseñado una estrategia exitosa para comercializar, importar y circular productos de vapeo con cannabis y nicotina, protegiéndote de prohibiciones y restricciones.
            </p>

            <p class="mt-4 text-center">
              <router-link class="btn btn-s2 outline-white" to="/contacto">CONTACTO</router-link>
            </p>
          </div>

          <div class="col-lg-6 col-paper">
            <img src="public/images/pages/info-pages/eum-legal.jpg">
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-2">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-title">
            <h2 class="title-s1">En EUM Legal</h2>
          </div>

          <div class="col-lg-6 offset-lg-1 col-text">
            <p>
              Estamos comprometidos con la transparencia, la lealtad y el bienestar de nuestros socios estratégicos de negocios. Nuestro enfoque basado en resultados garantiza una actuación eficaz y eficiente.
            </p>

            <h5 class="mt-4 subtitle">VALORES Y COMPROMISOS</h5>
            <p>
              Creemos en la prevención sobre la corrección, el respeto, la equidad y el desarrollo. Nuestro actuar es leal con los objetivos del cliente, siempre actuando con plena transparencia.
            </p>

            <p class="mt-4 text-center">
              <router-link class="btn btn-s2 outline-green" to="/contacto">CONTACTO</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-3">
      <div class="container">
        <div class="row">
          <div class="col-12 col-xl-10 mx-auto col-title">
            <h2 class="mb-1 title-s1">Catálogo de Servicios Legales</h2>
            <p>
              Nuestro catálogo de servicios legales está diseñado para atender todas tus necesidades relacionadas con el cannabis en México.
            </p>
          </div>

          <div class="col-lg-6 col-info" v-for="(s, shInx) in services" :key="'shInx-'+shInx">
            <h6 class="title">{{ s.title }}</h6>
            <p class="text">
              {{ s.text }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-4">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 pr-lg-4 pr-xl-5 col-info-1">
            <h2 class="title-s1">EUM Legal</h2>

            <p>
              Entendemos que actualmente es complicado comercializar cualquier tipo de aparato, mezcla y/o vapeador desechable;
            </p>

            <br />
            <p>
              Ya sea con cannabis o nicotina, sin embargo, en EUM hemos diseñado una estrategia que ha tenido éxito para comercializar importar y circular productos de vapeo con cannabis y con nicotina, dicha estrategia te protege de:
            </p>
          </div>

          <div class="col-lg-6 pl-lg-4 pl-xl-5 col-info-2">
            <div class="box-numbers">
              <div class="box-number">
                <h3 class="number">36</h3>
                <h5 class="text">Casos de éxito</h5>
              </div>

              <div class="box-number">
                <h3 class="number">26</h3>
                <h5 class="text">Amparos vigentes</h5>
              </div>
            </div>

            <div class="box-text">
              <p>
                Ley General de Control de Tabaco, artículo 16, fracción VI: prohíbe la comercialización de los vapeadores, porque no son productos de tabaco.
              </p>

              <br />
              <p>
                Prohibición de importación en diversas reformas y decretos para vapeadores, accesorios, mezclas y soluciones.
              </p>

              <br />
              <p>
                Decreto que prohibe comercialización y circulación en territorio nacional de los vapeadores.
              </p>

              <p class="mt-4 text-center">
                <router-link class="btn btn-s2 outline-white" to="/contacto">CONTACTO</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mx-auto col-testimonials">
            <div class="box-testimonials">
              <swiper class="swiper" :options="testimonialsOption">
                <swiper-slide v-for="(t, thInx) in testimonials" :key="'thInx-'+thInx">
                  <div class="box-testimonial">
                    <div class="comment">
                      <h5>{{ t.comment }}</h5>
                    </div>

                    <h6 class="name">{{ t.name }}</h6>
                  </div>
                </swiper-slide>

                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-6">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-9 col-lg-6 col-xl-5 col-image">
            <div class="image" v-bind:style="{ backgroundImage: 'url(public/images/pages/info-pages/alejandro.jpg)' }">
              <img src="public/images/shared/empty.png">
            </div>
          </div>

          <div class="col-lg-6 offset-xl-1 col-info">
            <h2 class="mb-1 title-s1">Sobre Nosotros</h2>

            <p class="mb-3">
              Alejandro Rosario es un abogado que cuenta con más de seis años de experiencia en diversas ramas del derecho como lo son la fiscal, financiera, sanitaria, regulatoria, propiedad industrial, corporativa, administrativa y penal.
            </p>
            <p class="mb-3">
              A lo largo de su joven, pero sustancial trayectoria, ha ocupado diversos cargos en start up's, asociaciones civiles y dependencias de gobierno en el ámbito del derecho obteniendo amplios resultados y llevando a cabo diversas publicaciones.
            </p>
            <p>
              Además, tiene ya tres años de experiencia en todo lo relacionado al marco jurídico de cannabis con diversas empresas del sector.
            </p>

            <div class="box-networks">
              <a class="t-150 btn-network" target="_blank" href="https://www.facebook.com/extractoseum">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a class="t-150 btn-network" target="_blank" href="https://twitter.com/Extractoseum">
                <i class="fab fa-twitter"></i>
              </a>
              <a class="t-150 btn-network" target="_blank" href="https://www.youtube.com/@extractoseum2886">
                <i class="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container info-section-7">
      <div class="row justify-content-center">
        <div class="col-12 col-info">
          <h1 class="mb-1 title-s1">Contacto</h1>

          <p class="p-lg">
            ¿Listo para Tomar el Control de tu Futuro en la Industria del Cannabis?.
          </p>
          <p>
            Nuestro equipo de expertos en EUM Legal está preparado para ayudarte a navegar por las complejas regulaciones y desarrollar estrategias personalizadas que se ajusten a tus necesidades. No dejes que las dudas legales te detengan. ¡Hagamos crecer tu negocio juntos!
          </p>
        </div>

        <div class="col-xl-9 col-form">
          <b-form @submit="onSubmit">
            <b-form-group class="form-group-s1"
              label="Nombre:">
              <b-form-input
                v-model="form.name"
                type="text"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="form-group-s1"
              label="Correo electrónico:">
              <b-form-input
                v-model="form.email"
                type="email"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="form-group-s1"
              label="Mensaje:">
              <b-form-textarea
                v-model="form.msg"
                placeholder=""
                rows="4"
                max-rows="4"
                required
              ></b-form-textarea>
            </b-form-group>

            <p class="text-center">
              <b-button type="submit" class="btn-s1 bg-cprimary">Enviar</b-button>
            </p>
          </b-form>
        </div>
      </div>
    </section>

    <section class="container info-section-8">
      <div class="row">
        <div class="col-lg-12 col-title">
          <h2 class="mb-1 title-s1">Casos de Éxito</h2>
        </div>

        <div class="col-sm-6 col-lg-3 col-story">
          <a class="box" target="_blank" href="public/pdfs/Vapeador-CBD-Grape-Ape-1000-mg.pdf">
            <div class="image">
              <img class="t-250" src="public/images/pages/info-pages/casos-1.jpg">
            </div>

            <h6 class="title">Amparo (Vape CBD)</h6>
          </a>
        </div>

        <div class="col-sm-6 col-lg-3 col-story">
          <a class="box" target="_blank" href="public/pdfs/Vapeador-CBD-Fresh-Lemon-1000-mg.pdf">
            <div class="image">
              <img class="t-250" src="public/images/pages/info-pages/casos-2.jpg">
            </div>

            <h6 class="title">Amparo (Vape CBD)</h6>
          </a>
        </div>

        <div class="col-sm-6 col-lg-3 col-story">
          <a class="box" target="_blank" href="public/pdfs/Importacion-y-distribucion-de-materia-prima-derivados-de-canamo-1.pdf">
            <div class="image">
              <img class="t-250" src="public/images/pages/info-pages/casos-3.jpg">
            </div>

            <h6 class="title">Amparo ( Importación y distribucion de materia prima derivados de cañamo)</h6>
          </a>
        </div>

        <div class="col-sm-6 col-lg-3 col-story">
          <a class="box" target="_blank" href="public/pdfs/Destilado-de-amplio-espectro-de-canamo.pdf">
            <div class="image">
              <img class="t-250" src="public/images/pages/info-pages/casos-4.jpg">
            </div>

            <h6 class="title">Amparo ( Destilado de amplio espectro de cáñamo)</h6>
          </a>
        </div>
      </div>
    </section>

    <section class="info-section-9">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-titles">
            <h2 class="title-s1">+20% EN PUNTOS</h2>
          </div>

          <div class="col-lg-7 offset-lg-1 col-info">
            <p class="p-lg">
              Unete a nuestro programa de afiliados, comparte y obtén hasta un 20% de tus compras en puntos redimibles y hasta un 20% de retribución en todas las compras que generen tus afiliados**
            </p>

            <p class="mt-4 p-sm">
              *(Aplicable en producto terminado -Gomitas, Goteros, Vapes y CandyKush Materias primas: CBD Aislado, Destilado CBD amplio espectro, Destilado CBD Espectro completo) promoción por tiempo indefinido.
            </p>
            <p class="mt-2 p-sm">
              *Sujeto a cambios sin previo aviso.
            </p>

            <p class="mt-4 text-center">
              <router-link class="btn btn-s2 outline-white" to="/login">UNIRME</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      services: [
        { title: 'Aviso de funcionamiento', text: 'Aviso de funcionamiento y de responsable sanitario para productos y medicamentos con cannabis.' },
        { title: 'Licencia sanitarias', text: 'Licencia sanitarias y registro sanitario para medicamentos con cannabis.' },
        { title: 'Desarrollo de estrategias', text: 'Desarrollo de estrategias jurídicas para garantizar el cumplimiento regulatorio.' },
        { title: 'Avisos y permisos', text: 'Avisos y permisos de publicidad para productos con cannabis.' },
        { title: 'Permisos de importación', text: 'Permisos de importación para productos derivados de cannabis.' },
        { title: 'Consultas', text: 'Consultas de información para productos con cannabis.' },
        { title: 'Asesoría especializada', text: 'Asesoría especializada para vapes y prerolados con o sin derivados de cannabis.' },
        { title: 'Asesoría', text: 'Asesoría y consultoría en general para productos con cannabis y su régimen legal en México.' },
        { title: 'Escritos libres', text: 'Escritos libres para solicitar autorización para siembra, cultivo y cosecha de cáñamo y cannabis en el ámbito industrial y farmacéutico.' },
        { title: 'Litigio estratégico', text: 'Litigio estratégico ante Tribunales Administrativos y jueces de Distrito (amparo).' },
        { title: 'Autorizaciones', text: 'Autorizaciones para uso lúdico de cannabis.' },
      ],

      testimonials: [
        { name: 'Empresa Farmacéutica', comment: 'Trabajar con EUM Legal ha sido una experiencia reveladora. Su conocimiento en regulaciones de cannabis y su enfoque proactivo nos ayudaron a obtener las licencias sanitarias necesarias en tiempo récord. ¡Un equipo verdaderamente profesional!' },
        { name: 'Importador de Productos de Cannabis', comment: 'La asesoría de EUM Legal en permisos de importación ha sido invaluable para nuestro negocio. Su estrategia personalizada nos permitió navegar por las complejas regulaciones mexicanas con facilidad. ¡Recomiendo sus servicios sin reservas!' },
        { name: 'Emprendedor en la Industria del Cannabis', comment: 'Como nuevo emprendedor en la industria del cannabis, me sentía perdido en el laberinto legal. EUM Legal no solo me guió a través de cada paso, sino que también me enseñó a prevenir problemas futuros. Su enfoque preventivo es simplemente brillante.' },
        { name: 'Empresa de Vapeadores', comment: 'La prohibición de comercialización de vapeadores fue un gran obstáculo para nosotros. Gracias a EUM Legal, pudimos diseñar una estrategia exitosa que nos permitió continuar con nuestro negocio en México. Su experiencia y dedicación son incomparables.' },
        { name: 'Cliente Individual para Uso Lúdico', comment: 'EUM Legal me ayudó a obtener una autorización para uso lúdico de cannabis. Su proceso fue transparente, eficiente y completamente profesional. Me sentí apoyado en cada etapa y estoy agradecido por su excelente servicio.' },
        { name: 'Organización de Salud', comment: 'La consultoría de EUM Legal en avisos y permisos de publicidad para productos con cannabis ha sido esencial para nuestra campaña de concientización. Su conocimiento y compromiso con la legalidad nos brindaron la confianza que necesitábamos.' },
      ],

      form: {
        name: null,
        email: null,
        msg: null,
      },

      // == Carousel options ==
      testimonialsOption: {
        loop: true,
        speed: 700,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },

        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
      },
      // == ==
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-bottom-right',
        appendToast: true
      })
    },

    onSubmit(event) {
      event.preventDefault();

      var params = this.form;
      var apiURL = tools.url("/api/contact");

      axios.post( apiURL,params )
      .then( (response) => {
        // alert(response.data.response);
        this.makeToast('success', response.data.response, 'Mensaje enviado');
        // alert(response.data.response);

        for (let prop in this.form) {
          this.form[prop] = '';
        }
      })
      .catch( (error) => {
        // console.log(error.response.data);
        let errors = error.response.data;

        for (let prop in errors) {
          // console.log(errors[prop]);
          this.makeToast('danger', errors[prop], '¡Error!');
        }
      });
    },
  }
}
</script>
